module.exports = __webpack_public_path__ + "static/media/walet.4644791f.png";